import script from "./EditProfileModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditProfileModal.vue?vue&type=script&setup=true&lang=ts"

import "./EditProfileModal.vue?vue&type=style&index=0&id=2b364b5c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b364b5c"]])

export default __exports__